import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import TextField from "@mui/material/TextField";
import { ROLES } from "../../../types/types";
import { dbUpdateUserDetails, createUser } from "../../../api/api";
import { addUser } from "../../../features/users/usersSlice";
import NotificationService from "../../../components/notification/NotificationService";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants";
import { validateEmail } from "../../../utils";

const CreateUser = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(ROLES.ADMIN);
  const [error, setError] = useState(true);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up("lg"));

  const submitNewUser = async () => {
    setLoading(true);
    await createUser(email, password, role).then((id) => {

      dispatch(
        addUser({
          id,
          email,
          role
        })
      );

      NotificationService.showToast({
        severity: "success",
        text: "Brugeren blev oprettet!",
        duration: 3000,
      });

      navigate(ROUTES.SUPER_ADMIN_USERS);
    }).catch((error) => {
      NotificationService.showToast({
        severity: "error",
        text: error.message,
        duration: 5000,
      });
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    if (
      !validateEmail(email)
    ) {
      setError(true);
    } else {
      setError(false);
    }
  }, [email, password]);

  return (
    <Container maxWidth={lgUp ? "sm" : "lg"}>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="flex" spacing={4}>
          <Typography variant="h4">Opret bruger</Typography>
        </Stack>
        <Card>
          <form autoComplete="off" noValidate onSubmit={() => { }}>
            <Card>
              <CardHeader subheader="Udfyld følgende oplysninger:" title="Ny bruger" />
              <CardContent sx={{ pt: 0 }}>
                <Box sx={{ m: -1.5 }}>
                  <Grid container>
                    <Grid xs={12} md={12} padding={1} item>
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        value={email}
                      />
                    </Grid>
                    <Grid xs={12} md={12} padding={1} item>
                      <TextField
                        fullWidth
                        label="Adgangskode"
                        name="password"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        value={password}
                        type="password"
                      />
                    </Grid>
                    <Grid xs={12} md={12} padding={1} item>
                      <TextField
                        fullWidth
                        label="Klub"
                        name="club"
                        onChange={(e) => setRole(e.target.value as ROLES)}
                        required
                        select
                        SelectProps={{ native: true }}
                        value={role}
                      >
                        {Object.values(ROLES).filter(option => option !== ROLES.SUPER_ADMIN).map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </TextField>
                    </Grid>

                  </Grid>
                </Box>
              </CardContent>
              <Divider />
              <CardActions sx={{ justifyContent: "space-between" }}>
                <div>
                  <Button
                    variant="outlined"
                    onClick={() => navigate(ROUTES.SUPER_ADMIN_USERS)}
                    sx={{ margin: "0px 10px" }}
                  >
                    Fortryd
                  </Button>
                  <Button
                    disabled={error}
                    variant="contained"
                    onClick={submitNewUser}
                  >
                    Opret
                  </Button>
                </div>
              </CardActions>
            </Card>
          </form>
        </Card>
      </Stack>
    </Container>
  );
};

export default CreateUser;
